import {Injectable} from "../../helpers";
import {AddonSetting} from "../models";

//example return this.IssetAddonInSubscriptionService.issetAddonFromClassAndAdminRoles(this.subAddons, 'CLASS_HOUSEKEEPING');
//TODO::perhaps it is better not to take a class string at the input, but the result of accessing the model already? then it will be like this:
//TODO::this.IssetAddonInSubscriptionService.issetAddonFromClassAndAdminRoles(this.subAddons, AddonSetting.CLASS_HOUSEKEEPING');
//TODO::addons.findIndex(addon => addon.class === addonClass) !== -1;

export class IssetAddonInSubscriptionService extends Injectable {

    static get $inject() {

        return [
            '$rootScope',
        ];
    }

    issetAddonFromClass(addons, addonClass) {

        return (addons || []).some(addon => addon.class === AddonSetting[addonClass]);
    }

    issetAddonFromClassAndAdminRoles(addons, addonClass) {

        return this.$rootScope.$user.isAdminRole() || this.issetAddonFromClass(addons, addonClass);
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/isset-addon-in-sunscription.service.js